import { IPAGE } from '@/types/base.d';
import fetch from './index';

// 分页获取海报列表
const getPosterList = (params: IPAGE) => fetch.axios_admin.get('/poster/template', { params });

// 添加海报
const upLoadPoster = (data: FormData) => fetch.axios_admin.post('/poster/template', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 删除海报
const removePoster = (id: string) => fetch.axios_admin.remove(`/poster/template?id=${id}`);

// 排序
const sortPoster = (data: object) => fetch.axios_admin.put('/poster/template/sequence', data);


export default {
  getPosterList,
  upLoadPoster,
  removePoster,
  sortPoster,
};
